<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 16H4.99998C4.22819 16 3.74732 15.1628 4.1362 14.4961L11.1362 2.49612C11.6505 1.61443 13 1.97925 13 2.99999V7.99999H19C19.7718 7.99999 20.2526 8.8372 19.8638 9.50386L12.8638 21.5039C12.3494 22.3855 11 22.0207 11 21V16ZM11 6.69891L6.74102 14H12C12.5523 14 13 14.4477 13 15V17.3011L17.2589 9.99999H12C11.4477 9.99999 11 9.55227 11 8.99999V6.69891Z"
    fill="currentColor"
  />
</svg>
